/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Model } from '@app/shared/models/model.model';
import { CountriesSeo } from '@app/settings/countries/countries-seo.model';

export class Country extends Model {
  id: number;
  code: string;
  name: string;
  phone_code: number;
  timezone: string;
  active: boolean;
  translations?: Array<CountriesSeo>;
  // cities?: Array<City>;
  //
  // deserialize(input: any): this {
  //   super.deserialize(input);
  //
  //   if (input.cities) {
  //     input.cities.forEach((city: {}) => {
  //       input.cities.push(new City().deserialize(city));
  //     });
  //   }
  //
  //   return this;
  // }
}
